import { createSlice } from "@reduxjs/toolkit";
import { exchangeToken, login } from "../../app/services/auth";
import jwt_decode from "jwt-decode";

// Re-decode JWT from localStorage on app initialization
const getInitialAuthState = () => {
    try {
        const stored = localStorage.getItem('auth')
        if (stored) {
            const parsed = JSON.parse(stored)
            if (parsed.access_token) {
                const decoded = jwt_decode(parsed.access_token)
                return {
                    access_token: parsed.access_token,
                    is_mcjeans_employee: decoded.is_mcjeans_employee || false,
                    status: 'fulfilled'
                }
            }
        }
    } catch (error) {
        console.error('Error initializing auth from localStorage:', error)
    }
    return {
        access_token: null,
        is_mcjeans_employee: false,
        status: 'idle'
    }
}

const initialState = {
    auth: getInitialAuthState()
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(exchangeToken.pending, (state) => {
            state.auth.status = 'pending'
        })
        builder.addCase(exchangeToken.fulfilled, (state, action) => {
            state.auth.status = 'fulfilled'
            state.auth.access_token = action.payload.access_token

            // Decode JWT and store is_mcjeans_employee
            try {
                const decoded = jwt_decode(action.payload.access_token)
                state.auth.is_mcjeans_employee = decoded.is_mcjeans_employee || false
            } catch (error) {
                console.error('Error decoding token:', error)
                state.auth.is_mcjeans_employee = false
            }
        })
        builder.addCase(exchangeToken.rejected, (state, action) => {
            state.auth.status = 'rejected'
        })

        builder.addCase(login.pending, (state) => {
            state.auth.status = 'pending'
        })
        builder.addCase(login.fulfilled, (state, action) => {
            state.auth.status = 'fulfilled'
            state.auth.access_token = action.payload.access_token

            // Decode JWT and store is_mcjeans_employee
            try {
                const decoded = jwt_decode(action.payload.access_token)
                state.auth.is_mcjeans_employee = decoded.is_mcjeans_employee || false
            } catch (error) {
                console.error('Error decoding token:', error)
                state.auth.is_mcjeans_employee = false
            }
        })
        builder.addCase(login.rejected, (state, action) => {
            state.auth.status = 'rejected'
        })
    }
})

export const selectAuth = (store) => store.auth.auth
export const selectIsMcjeansEmployee = (store) => store.auth.auth.is_mcjeans_employee
export default authSlice.reducer